import './index.scss';

export const aside = {
    init: function () {
        const $buttonProductReview = document.querySelector('.js-button-product-review');
        const $productReview = document.querySelector('.js-product-review');

        if ($productReview && ($productReview.offsetHeight < $productReview.scrollHeight)) {
            $buttonProductReview.hidden = false;
        }

        if ($buttonProductReview !== null) {
            $buttonProductReview.addEventListener('click', function () {
                if ($productReview.classList.contains('active')) {
                    $productReview.classList.remove('active');
                    $buttonProductReview.innerText = 'Подробнее';
                } else {
                    $productReview.classList.add('active');
                    $buttonProductReview.innerText = 'Свернуть';
                }
            });
        }
    },
};

